/**
 * Created by Hideo Yamada
 * 07/01/2019
 * https://marvelapp.com/53405j1/screen/50159470
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import moment from 'moment';
import Avatar from '@components/@core/Avatar';
import CheckBox from '@components/@core/CheckBox';
import DatePicker from '@components/@core/DatePicker';
import Dropdown from '@components/@core/Dropdown';
import EditDropdown from '@components/EditDropdown';
import Thumbnail from '@components/@core/Thumbnail';

const dotsMenu = ['Remove'];

const CourseItem = ({ className, editable, course, scheduleUsers, employees, minDate, maxDate, onChangeDate, onChangeUsers, onRemove }) => {
    const { status, description, users } = course;
    const isCompleted = status === 3;
    const thumbnail = course.thumbnail || course.data ? course.data.thumb_url : '';
    const dueDate = !course.due_date ? course.end_at : course.due_date;
    const title = course.name || course.title;
    const completed = editable ? '' : (course.stats.completed / course.stats.assigned).toFixed(2) * 100;
    let selectedUser = scheduleUsers ? scheduleUsers : users;
    selectedUser = selectedUser.length == 0 ? null : selectedUser;

    return (
        <div className={classNames('d-flex ssm-column border-bottom py-3 ai-center', className)}>
            <div className="d-flex-12 d-flex ai-center">
                <div className="d-flex flex-grow-1 ai-center">
                    <CheckBox className="pr-3" checked={isCompleted} size="regular" />
                    <Thumbnail className="pr-3" source={thumbnail} size="tiny" />
                    <div className="pr-3">
                        <p className={classNames('dsl-m14 text-400 mb-1 truncate-one', isCompleted && 'text-line-through')}>{title}</p>
                        <p className={classNames('dsl-m12 mb-0 truncate-two', isCompleted && 'text-line-through')}>{description}</p>
                    </div>
                </div>
                <div className="mobile-screen">
                    {editable && (
                        <div className="d-flex-1 d-h-end">
                            <EditDropdown options={dotsMenu} onChange={onRemove} />
                        </div>
                    )}
                </div>
            </div>
            <div className={classNames('d-flex-3 d-h-end ssm-jc-between w-100 py-2 py-sm-0', editable ? 'd-flex' : 'ai-s-center')}>
                <label className="mobile-screen dsl-m14 mb-0">Assigned</label>
                {editable ? (
                    <Dropdown multi width="fit-content" disabled={!editable} defaultIds={selectedUser} data={employees} align="right" getValue={(e) => e.name} onChange={onChangeUsers} />
                ) : (
                    <div className="employees-detail">
                        <p className="dsl-m14 mb-0 text-400 text-end">{selectedUser?.length}</p>
                        <div className="employees-detail-modal">
                            {selectedUser?.length !== 0 && (
                                <>
                                    <div className="d-flex">
                                        <div className="d-flex-4">
                                            <p className="dsl-m10 text-400 text-start">Employee</p>
                                        </div>
                                    </div>
                                    {selectedUser?.map((id) => {
                                        const user = find(propEq('id', id), employees);
                                        if (user) {
                                            return (
                                                <div className="d-flex py-1" key={id}>
                                                    <div className="d-flex d-flex-4">
                                                        <Avatar className="d-flex-1" name={user.name} url={user.profile.avatar} size="extraTiny" />
                                                        <div className="d-flex-3 dsl-b12 ms-2 text-start text-400 ai-s-center">{user.name}</div>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    })}
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
            {!editable && (
                <div className="d-flex-2 d-flex w-100 py-2 py-sm-0">
                    <label className="mobile-screen dsl-m14 mb-0">completed</label>
                    <div className="d-flex-2 dsl-m14 text-400 text-end ai-s-center">{completed}%</div>
                </div>
            )}
            {editable ? (
                <div className="d-flex-3 d-h-center ssm-jc-between w-100 py-2 py-sm-0">
                    <label className="mobile-screen dsl-m14 mb-0">Due Date</label>
                    <DatePicker
                        placeholder="Select"
                        closeAfterSelect
                        title={!dueDate ? 'Select' : moment(dueDate).format('MMM D')}
                        value={!dueDate ? moment() : moment(dueDate)}
                        calendar="day"
                        append="caret"
                        align="right"
                        minDate={new Date(minDate)}
                        maxDate={new Date(maxDate)}
                        onSelect={(e) => onChangeDate(moment(e).format('YYYY-MM-DD'))}
                    />
                </div>
            ) : (
                <div className="d-flex-3 d-flex jc-center dsl-m14 text-400 w-100 py-2 py-sm-0">
                    <label className="mobile-screen dsl-m14 mb-0">Due Date</label>
                    <div className="d-flex-2 dsl-m14 text-400 text-center ssm-right ai-s-center">{!dueDate ? moment() : moment(dueDate).format('MMM D')}</div>
                </div>
            )}
            {editable && (
                <div className="d-flex-1 d-h-end desktop-screen">
                    <EditDropdown options={dotsMenu} onChange={onRemove} />
                </div>
            )}
        </div>
    );
};

CourseItem.propTypes = {
    course: PropTypes.any,
    editable: PropTypes.bool,
    className: PropTypes.string,
    employees: PropTypes.array,
    minDate: PropTypes.any,
    maxDate: PropTypes.any,
    onChangeDate: PropTypes.func,
    onChangeUsers: PropTypes.func,
    onRemove: PropTypes.func,
};

CourseItem.defaultProps = {
    course: {},
    editable: false,
    className: '',
    employees: [],
    minDate: null,
    maxDate: null,
    onChangeDate: () => {},
    onChangeUsers: () => {},
    onRemove: () => {},
};

export default memo(CourseItem);
